import { Link } from 'react-router-dom';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Divider, Grid, Stack, Typography, useMediaQuery, Box, Paper, Fade } from '@mui/material';

// project imports
import AuthWrapper1 from '../AuthWrapper1';
import AuthCardWrapper from '../AuthCardWrapper';
import AuthResetPassword from '../auth-forms/AuthResetPassword';

// icons
import VpnKeyOutlinedIcon from '@mui/icons-material/VpnKeyOutlined';

// ================================|| AUTH3 - RESET PASSWORD ||================================ //

const ResetPassword = () => {
  const theme = useTheme();
  const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <AuthWrapper1>
      <Grid
        container
        direction="column"
        justifyContent="flex-end"
        sx={{
          minHeight: '100vh',
          background: `linear-gradient(135deg, ${theme.palette.grey[100]} 0%, ${theme.palette.grey[300]} 100%)`,
          position: 'relative',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: `radial-gradient(circle at 20% 80%, ${theme.palette.primary.light}20 0%, transparent 50%),
                        radial-gradient(circle at 80% 20%, ${theme.palette.secondary.light}20 0%, transparent 50%)`,
            pointerEvents: 'none'
          }
        }}
      >
        <Grid item xs={12}>
          <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: 'calc(100vh - 68px)' }}>
            <Grid item sx={{ m: { xs: 1, sm: 3 }, mb: 0 }}>
              <Fade in={true} timeout={800}>
                <Box>
                  <Paper
                    elevation={24}
                    sx={{
                      borderRadius: '12px',
                      overflow: 'hidden',
                      background: '#ffffff',
                      border: '1px solid',
                      borderColor: theme.palette.divider,
                      position: 'relative',
                      maxWidth: 480,
                      '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        height: '4px',
                        background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`
                      }
                    }}
                  >
                    <AuthCardWrapper>
                      <Grid container spacing={3} alignItems="center" justifyContent="center">
                        {/* Header */}
                        <Grid item xs={12}>
                          <Box sx={{ textAlign: 'center', mb: 2 }}>
                            <Box
                              sx={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: theme.palette.success.light + '20',
                                borderRadius: '16px',
                                p: 2,
                                mb: 3,
                                border: '1px solid',
                                borderColor: theme.palette.success.light + '50'
                              }}
                            >
                              <VpnKeyOutlinedIcon
                                sx={{
                                  fontSize: 48,
                                  color: theme.palette.success.main
                                }}
                              />
                            </Box>

                            <Typography
                              variant="h3"
                              sx={{
                                fontWeight: 700,
                                color: theme.palette.grey[800],
                                mb: 0.5,
                                letterSpacing: '-0.5px'
                              }}
                            >
                              Nueva Contraseña
                            </Typography>

                            <Typography
                              variant="body2"
                              sx={{
                                color: theme.palette.grey[600],
                                fontWeight: 400
                              }}
                            >
                              PMS SegoCloud
                            </Typography>
                          </Box>
                        </Grid>

                        <Grid item xs={12}>
                          <Divider sx={{ mb: 2 }}>
                            <Typography
                              variant="caption"
                              sx={{
                                color: theme.palette.grey[500],
                                px: 2,
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                fontWeight: 500
                              }}
                            >
                              Crear Contraseña Segura
                            </Typography>
                          </Divider>
                        </Grid>

                        <Grid item xs={12}>
                          <Box>
                            <AuthResetPassword />
                          </Box>
                        </Grid>

                        <Grid item xs={12}>
                          <Divider sx={{ my: 2 }} />
                        </Grid>

                        <Grid item xs={12}>
                          <Grid item container direction="column" alignItems="center" xs={12}>
                            <Typography
                              component={Link}
                              to="/login"
                              variant="subtitle2"
                              sx={{
                                textDecoration: 'none',
                                color: theme.palette.primary.main,
                                fontWeight: 600,
                                '&:hover': {
                                  color: theme.palette.primary.dark,
                                  textDecoration: 'underline'
                                }
                              }}
                            >
                              Volver al Inicio de Sesión
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                    </AuthCardWrapper>
                  </Paper>
                </Box>
              </Fade>
            </Grid>
          </Grid>
        </Grid>

        {/* Footer */}
        <Box
          sx={{
            py: 3,
            px: 2,
            textAlign: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.03)',
            borderTop: '1px solid',
            borderColor: theme.palette.divider
          }}
        >
          <Typography variant="caption" color="text.secondary">
            © {new Date().getFullYear()} PMS SegoCloud. Todos los derechos reservados.
          </Typography>
        </Box>
      </Grid>
    </AuthWrapper1>
  );
};

export default ResetPassword;
